module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "certificate"
  }, [_c('div', {
    staticStyle: {
      "min-height": "calc(100% - 220px)",
      "box-sizing": "border-box"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "commonW"
  }, [_c('div', {
    staticClass: "step02",
    staticStyle: {
      "max-width": "780px",
      "margin": "0 auto"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("证书信息")]), _vm._v(" "), _c('el-card', {
    staticClass: "box-card",
    attrs: {
      "shadow": "never"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "120px",
      "margin-top": "20px"
    },
    attrs: {
      "src": require("../assets/certificate.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "securityInfo"
  }, [_c('div', {
    staticClass: "info textBreak"
  }, [_vm._v("项目名称：" + _vm._s(_vm.securityInfo.projectId) + " " + _vm._s(_vm.securityInfo.projectName))]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_vm._v("电梯有效期授权至：" + _vm._s(_vm.securityInfo.elevatorAuthTime == 'FFFFFFFF' ? '长期有效' : _vm.securityInfo.elevatorAuthTime))]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_vm._v("门禁有效期授权至：" + _vm._s(_vm.securityInfo.entranceAuthTime == 'FFFFFFFF' ? '长期有效' : _vm.securityInfo.entranceAuthTime))])])]), _vm._v(" "), _c('el-form', {
    ref: "downForm",
    attrs: {
      "model": _vm.downForm,
      "label-position": "left"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "",
      "prop": "type"
    }
  }, [_c('span', {
    staticClass: "itemlabel",
    staticStyle: {
      "letter-spacing": "4px"
    }
  }, [_vm._v("证书类型：")]), _vm._v(" "), _c('span', {
    staticClass: "spanBtn xsBtn",
    class: _vm.downForm.licenseType == 1 ? 'primary' : '',
    on: {
      "click": function($event) {
        return _vm.changeType(1)
      }
    }
  }, [_vm._v("正式证书")]), _vm._v(" "), _c('span', {
    staticClass: "spanBtn xsBtn",
    class: _vm.downForm.licenseType == 2 ? 'primary' : '',
    on: {
      "click": function($event) {
        return _vm.changeType(2)
      }
    }
  }, [_vm._v("工程调试证书")])]), _vm._v(" "), (_vm.typeRule) ? _c('div', {
    staticClass: "question red"
  }, [_vm._v("证书类型属于必填项")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "question",
    on: {
      "click": function($event) {
        return _vm.toQuestions('3')
      }
    }
  }, [_vm._v("证书类型区别是什么？")]), _vm._v(" "), (_vm.downForm.licenseType == 1) ? _c('el-form-item', {
    attrs: {
      "prop": "type"
    }
  }, [_c('span', {
    staticClass: "itemlabel"
  }, [_vm._v("电脑特征码：")]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    ref: "table",
    staticStyle: {
      "width": "85%",
      "float": "right",
      "margin-bottom": "10px"
    },
    attrs: {
      "data": _vm.lists,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "pcInfo",
      "label": "电脑特征值",
      "min-width": "240"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 1) ? _c('el-form', {
          attrs: {
            "model": scope.row
          }
        }, [_c('el-form-item', {
          attrs: {
            "prop": "pcInfo"
          }
        }, [_c('el-input', {
          attrs: {
            "type": "text",
            "auto-complete": "off",
            "name": "textfield",
            "placeholder": "请输入电脑特征值",
            "maxlength": 255
          },
          nativeOn: {
            "keydown": function($event) {
              return _vm.changeValue.apply(null, arguments)
            }
          },
          model: {
            value: (scope.row.pcInfo),
            callback: function($$v) {
              _vm.$set(scope.row, "pcInfo", $$v)
            },
            expression: "scope.row.pcInfo"
          }
        })], 1)], 1) : _c('tooltip-hint', {
          attrs: {
            "sendTooltipInfo": scope.row.pcInfo
          }
        })]
      }
    }], null, false, 1007644166)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "",
      "min-width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 1) ? _c('div', [_c('el-upload', {
          staticStyle: {
            "display": "inline-block"
          },
          attrs: {
            "action": "",
            "accept": "image/png, image/jpeg, image/jpg",
            "show-file-list": false,
            "http-request": _vm.resolveQR
          }
        }, [_c('el-button', {
          attrs: {
            "type": "primary",
            "icon": "el-icon-upload2",
            "size": "medium"
          }
        }, [_vm._v("上传")])], 1), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium",
            "loading": _vm.saveCertLoading
          },
          on: {
            "click": function($event) {
              return _vm.saveCert(scope.$index)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-floppy-o"
        }, [_vm._v("  保存")])])], 1) : _vm._e()]
      }
    }], null, false, 857169468)
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "el-table-add-row",
    on: {
      "click": _vm.addCert
    }
  }, [_c('span', [_vm._v("+ 新增")])])], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "拍摄",
      "visible": _vm.visible,
      "width": "1065px"
    },
    on: {
      "update:visible": function($event) {
        _vm.visible = $event
      },
      "close": _vm.onCancel
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('video', {
    staticClass: "canvas",
    attrs: {
      "id": "videoCamera",
      "width": _vm.videoWidth,
      "height": _vm.videoHeight,
      "autoPlay": ""
    }
  }), _vm._v(" "), _c('canvas', {
    staticClass: "canvas",
    attrs: {
      "id": "canvasCamera",
      "width": _vm.videoWidth,
      "height": _vm.videoHeight
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "icon": "el-icon-camera",
      "size": "small"
    },
    on: {
      "click": _vm.drawImage
    }
  }, [_vm._v("拍照")]), _vm._v(" "), (_vm.open) ? _c('el-button', {
    attrs: {
      "icon": "el-icon-video-camera",
      "size": "small"
    },
    on: {
      "click": _vm.getCompetence
    }
  }, [_vm._v(" 打开摄像头")]) : _c('el-button', {
    attrs: {
      "icon": "el-icon-switch-button",
      "size": "small"
    },
    on: {
      "click": _vm.stopNavigator
    }
  }, [_vm._v(" 关闭摄像头")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-refresh",
      "size": "small"
    },
    on: {
      "click": _vm.resetCanvas
    }
  }, [_vm._v(" 重置 ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-circle-close",
      "size": "small"
    },
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v(" 取消 ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "loading": _vm.loading,
      "type": "primary",
      "icon": "el-icon-upload2",
      "size": "small"
    },
    on: {
      "click": _vm.onUpload
    }
  }, [_vm._v(" 上传 ")])], 1)]), _vm._v(" "), (_vm.pcInfoRule) ? _c('div', {
    staticClass: "question red"
  }, [_vm._v(_vm._s(_vm.errTip))]) : _vm._e(), _vm._v(" "), (_vm.downForm.licenseType == 1) ? _c('div', {
    staticClass: "question",
    on: {
      "click": function($event) {
        return _vm.toQuestions('2')
      }
    }
  }, [_vm._v("如何查看找到电脑特征码？")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "680px",
      "text-align": "center",
      "margin-top": "80px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.downLoading
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.downLoadLcx.apply(null, arguments)
      }
    }
  }, [_vm._v("下载\r\n        ")])], 1)], 1)], 1)])]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "assessTit"
  }, [_c('div', {
    staticClass: "commonW",
    staticStyle: {
      "padding-top": "16px"
    }
  }, [_c('div', {
    staticClass: "left"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/wangLG.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('span', [_c('img', {
    attrs: {
      "src": require("../assets/tel.png")
    }
  })]), _vm._v("  400-777-5999")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer clear-fix",
    staticStyle: {
      "min-width": "1100px",
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "max-width": "1100px",
      "margin": "0 auto"
    }
  }, [_c('div', {
    staticClass: "aboutUs"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("关于我们")]), _vm._v(" "), _c('div', [_c('a', {
    staticStyle: {
      "color": "#C0C0C0"
    },
    attrs: {
      "target": "_blank",
      "href": "http://www.itlong.com.cn/about.html",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("企业介绍")])]), _vm._v(" "), _c('div', [_c('a', {
    staticStyle: {
      "color": "#C0C0C0"
    },
    attrs: {
      "target": "_blank",
      "href": "http://www.itlong.com.cn/qiyewenhua.html",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("企业文化")])]), _vm._v(" "), _c('div', [_c('a', {
    staticStyle: {
      "color": "#C0C0C0"
    },
    attrs: {
      "target": "_blank",
      "href": "http://www.itlong.com.cn/zizhirongyu.html",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("资质荣誉")])]), _vm._v(" "), _c('div', [_c('a', {
    staticStyle: {
      "color": "#C0C0C0"
    },
    attrs: {
      "target": "_blank",
      "href": "http://www.itlong.com.cn/hezuohuoban73.html",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("合作伙伴")])]), _vm._v(" "), _c('div', [_c('a', {
    staticStyle: {
      "color": "#C0C0C0"
    },
    attrs: {
      "target": "_blank",
      "href": "http://www.itlong.com.cn/pinpaiziyuan.html",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("品牌资源")])])]), _vm._v(" "), _c('div', {
    staticClass: "footerBor footerBor1"
  }), _vm._v(" "), _c('div', {
    staticClass: "concatUs"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("联系我们")]), _vm._v(" "), _c('div', [_vm._v("总　　机　0755-86675999 ")]), _vm._v(" "), _c('div', [_vm._v("销售邮箱　shangwu@itlong.com.cn")]), _vm._v(" "), _c('div', [_vm._v("售后邮箱　fw@itlong.com.cn")]), _vm._v(" "), _c('div', [_vm._v("总部地址　深圳市南山区学苑大道1001号南山智园C1栋12楼")]), _vm._v(" "), _c('div', [_vm._v("邮　　编　518055   ")])]), _vm._v(" "), _c('div', {
    staticClass: "footerBor footerBor2"
  }), _vm._v(" "), _c('div', {
    staticClass: "company"
  }, [_c('div', [_vm._v("Copyright © 1997-2021 版权所有:深圳市旺龙智能科技有限公司")]), _vm._v(" "), _c('div', [_vm._v("粤ICP备18085992号")]), _vm._v(" "), _c('div', [_vm._v("旺龙智能-为您提供智能云梯控，云门禁，云对讲报价、价格、采购，智能云梯控、云门禁、云对讲品牌商，厂家，供应商，批发商！")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-1e3455cf"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/Certificate.vue
// module id = 796
// module chunks = 1